const BOT_USER_AGENT_PATTERN =
  /bot|crawler|spider|slurp|bingpreview|facebookexternalhit|headlesschrome|lighthouse|pingdom/i

export const isBotUserAgent = (userAgent: string): boolean => BOT_USER_AGENT_PATTERN.test(userAgent)
